import {IOwayoDataModel} from "../model";
import {ISnapshotTaker} from "../owayoJSViewerWithSelObs";
import {owayoUtils} from "../owayoUtils";
import {EventVerteiler} from "../../global/eventVerteiler";
import {getURLPrefixOfflineVsOnline} from "../../global/globalUtils";
import globalsObject from "../globalsObject";
import DEBUG from "../DEBUG";
import {sendPostRequest} from "../../global/axiosFormWrapper";
import axios from "axios";

declare class FB {
    static ui(obj: { method: string; action_type: string; action_properties: string; app_id: number; display: string; }, arg1: () => void)
    static init(arg0: {
        appId: string; cookie: boolean; // enable cookies to allow the server to access
        // the session
        xfbml: boolean; // parse social plugins on this page
        version: string; // original: use version 2.1
    })
    static getLoginStatus(arg0: (response: any) => void)
    static api(s, callback, p: { scrape: boolean; id: string[] }, p1: () => void);
}



export class ShareDraftController {
    private static snapshotTaker: ISnapshotTaker;

    public static setSnapshotTaker(snapshotViewComponent:ISnapshotTaker) {
        ShareDraftController.snapshotTaker = snapshotViewComponent;
    }

    private static loadFBApi(model:IOwayoDataModel, callback) {


        function testAPI() {
            //noinspection JSUnresolvedFunction
            FB.api('/me', function (response) {
                if (DEBUG) {
                    console.log('Successful account for: ' + response.name);
                }
            }, {
                id: ["https://" + model.getDomain() + "/"
                + model.getWebSportFuerProduktAuswahlInt() + "-" + model.getCurrentOwayoProduct().productWebInt + "/facebookdesign.htm?ID=" + model.entwurf.getFBPostID() + "&src=fbxzy"],
                scrape: true
            }, () => EventVerteiler.broadcast("displayDialogEvent", {
                dialog: "shareOnFacebook",
                callbacks: [() => ShareDraftController.makeFBApiCall(model)]
            }));
        }

        function statusChangeCallback(response) {
            if (response.status === 'connected') {
                testAPI();
            }
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        function checkLoginState() {
            FB.getLoginStatus(function (response) {
                statusChangeCallback(response);
            });
        }

        (window as any).fbAsyncInit = function () {
            FB.init({
                appId: '825135010881419',
                cookie: true,  // enable cookies to allow the server to access
                               // the session
                xfbml: true,  // parse social plugins on this page
                version: 'v2.3' // original: use version 2.1
            });

            FB.getLoginStatus(function (response) {
                statusChangeCallback(response);
            });
            if (typeof(callback) === "function") {
                callback();
            }

        };

        // Load the SDK asynchronously
        (function (d, s, id) {
            const fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            const js = d.createElement(s) as HTMLScriptElement;
            js.id = id;
            js.src = "//connect.facebook.net/" + model.getSprache().toUpperCase() + "/sdk.js";
            (fjs.parentNode as HTMLElement).insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));


    }

    private static makeFBApiCall(model:IOwayoDataModel) {

        if (model.entwurf.getFBPostID() === "") {
            if (DEBUG) {
                alert("id not defined");
            }
            return;
        }
        const obj = {
            method: 'share_open_graph',
            action_type: 'owayo_konfigurator:design',
            action_properties: JSON.stringify({
                jersey: "https://" + model.getDomain() + "/"
                    + model.getWebSportFuerProduktAuswahlInt() + "-" + model.getCurrentOwayoProduct().productWebInt + "/facebookdesign.htm?ID=" + model.entwurf.getFBPostID() + "&src=fbxzy"
            }),
            app_id: 825135010881419,
            display: "popup"
        };

        // noinspection TypeScriptValidateJSTypes
        FB.ui(obj, function () {
        });

    }

    public static shareEntwurf(target:string, aWindow:Window|null, model:IOwayoDataModel, shareByEmailInfo?: { benutzername: any; ihreemail: any; email: any; nachricht: any; }):Promise<any> {
        return new Promise(resolve => {
            const angles  = owayoUtils.createAngleArray(20);
            const images = ShareDraftController.snapshotTaker.takeSnapshots(angles);

            if (target === "fb") {
                ShareDraftController.initFacebookCallbacksForSharing(model);
            }
            if (target === "wa") {
                ShareDraftController.initWhatsappCallbacksForSharing(model, aWindow);
            }

            const data = {
                images: images,
                sportart: model.getWebSportFuerProduktAuswahlInt(),
                produkt: model.getCurrentOwayoProduct().productWebInt,
                facebook: (target === "fb"),
                whatsapp: (target === "wa"),
                sprache: model.getSprache(),
                login: model.user.getUserName(),
                saveID: model.entwurf.getID(),
                benutzername:undefined,
                ihreemail:undefined,
                email:undefined,
                nachricht:undefined,
            };
            if (target === "mail") {
                data.benutzername = shareByEmailInfo.benutzername;
                data.ihreemail = shareByEmailInfo.ihreemail;
                data.email = shareByEmailInfo.email;
                data.nachricht = shareByEmailInfo.nachricht;
            }

            ShareDraftController.sendDataToServerToPrepareFacebookPost(data/*, model*/).then((data)=>resolve(data));
        })

    }

    private static sendDataToServerToPrepareFacebookPost(data, /*model:IOwayoDataModel*/):Promise<any> {
        return new Promise(resolve => {

            const url = [
                // globalUtils.getHTTPForLocalhostHTTPSForOnline(),
                // model.getDomain(),
                getURLPrefixOfflineVsOnline(),
                "/",
                "prepareFacebookPost.php"
            ].join("");
            sendPostRequest(url, data).then(response=>{
                EventVerteiler.broadcastBlockRequestEnded("prepareFB_PHP");
                resolve(response.data)
            })
        })

    }

    private static initFacebookCallbacksForSharing(model:IOwayoDataModel) {

        if (typeof(FB) === "undefined") {
            ShareDraftController.loadFBApi(model, ()=>globalsObject.resourceManager.registerLoadedResourceWithoutData("loadFB"));
        }
        globalsObject.resourceManager.createTask("makeFBApiCallPreparation")
            .when("loadFB", "loaded")
            .andWhen("prepareFB_PHP", "loaded")
            .thenDo(function(){
                FB.api('https://graph.facebook.com/', 'post',
                    {
                        id: ["https://" + model.getDomain() + "/"
                        + model.getWebSportFuerProduktAuswahlInt() + "-" + model.getCurrentOwayoProduct().productWebInt + "/facebookdesign.htm?ID=" + model.entwurf.getFBPostID() + "&src=fbxzy"],
                        scrape: true
                    },
                    ()=>EventVerteiler.broadcast("displayDialogEvent", {dialog: "shareOnFacebook",callbacks: [()=>ShareDraftController.makeFBApiCall(model)]})
                );
            })
    }

    public static PostMessageToLoadingWindow(aWindow:Window|null, type: string, payload?: any){
        try {
            aWindow?.postMessage({ source: "owayo-share-wa", type, payload }, window.location.origin);
        } catch (e) {
            // ignore
        }
    }

    private static initWhatsappCallbacksForSharing(model:IOwayoDataModel, aWindow:Window|null) {
        globalsObject.resourceManager.createTask("makeWAApiCallPreparation")
            .when("prepareWA_PHP", "loaded")
            .thenDo(function(){
                const url = "https://" + model.getDomain() + "/" + model.getWebSportFuerProduktAuswahlInt() + "-" + model.getCurrentOwayoProduct().productWebInt + "/facebookdesign.htm?ID=" + model.entwurf.getFBPostID() + "&src=waxzy";
                const waUrl = `https://wa.me/?text=${encodeURIComponent(url)}`;

                ShareDraftController.PostMessageToLoadingWindow(aWindow, "stage", { key: "opening" });
                if (aWindow) {
                    let loadingHref = aWindow.location.href;
                    aWindow.location.href = waUrl;

                    window.setTimeout(() => {
                        if (!aWindow || aWindow.closed) return;
                        try {
                            if (aWindow.location.href === loadingHref) {
                                aWindow.close();
                            }
                        } catch (e) {
                            // cross-origin => wa.me hat geladen => Fenster NICHT schließen
                        }
                    }, 2500);
                } else {
                    window.open(waUrl, '_blank');
                }
            });
    }

    public static createPDF(model:IOwayoDataModel, infoEmailAdresse) {
        EventVerteiler.broadcastBlockRequest("createPDF");
        const images = ShareDraftController.snapshotTaker.takeSnapshots([30, -30, 150, 210]);
        (document.getElementById("pdfcreation_images") as HTMLInputElement).value = (JSON.stringify(images));
        (document.getElementById("pdfcreation_login") as HTMLInputElement).value = (model.user.getUserName());
        (document.getElementById("pdfcreation_datumstring") as HTMLInputElement).value = (new Date().toLocaleDateString(model.getLocale()));
        (document.getElementById("pdfcreation_product") as HTMLInputElement).value = (model.getCurrentOwayoProduct().name);
        (document.getElementById("pdfcreation_saveid") as HTMLInputElement).value = (model.entwurf.getID());
        (document.getElementById("pdfcreation_entwurfname") as HTMLInputElement).value = (model.entwurf.getName());
        (document.getElementById("pdfcreation_infoadresse") as HTMLInputElement).value = (infoEmailAdresse);
        (document.getElementById("pdfcreation_sprache") as HTMLInputElement).value = (model.getLanguageIso());
        (document.getElementById("pdfCreation") as HTMLFormElement).submit();
        EventVerteiler.broadcastBlockRequestEnded("createPDF");
    }
}
